import { observer } from 'mobx-react';
import React, { ChangeEvent, useCallback } from 'react';
import dealsStore from '../../store/dealsStore';
import { IDealsItemValidation } from '../../types/deals';
import { modalStore } from 'src/mobx/modalStore';
import { IDealItem } from 'src/types/combo';
import { formatPrice } from 'src/utils/formatter';
import { getTranslate, stringTransform } from 'src/utils/helpers';
import { floatNumbersValidation } from 'src/utils/validation';
import InputAlt from 'src/view/components/Controls/InputAlt/InputAlt';
import FakePicker from 'src/view/components/Controls/Pickers/FakePicker/FakePicker';
import DeleteRestoreBlock from 'src/view/components/DeleteRestoreBlock/DeleteRestoreBlock';
import { ProductWarning } from '~/view/components/ProductWarning';
import './style.scss';

interface IProps {
  item: IDealItem;
}
const DealsItem: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  const itemValidation: IDealsItemValidation | undefined = dealsStore.validation.items.find((item) => item.id === props.item.id);

  const openItemsModal = () => {
    if (!dealsStore.deal) return;
    modalStore.openItemsForDealModal({
      selectedItems: dealsStore.deal.items,
      onSave: dealsStore.addItem,
      isMulti: true,
    });
  };

  const handleDelete = useCallback(() => {
    dealsStore.deleteItem(props.item.id);
  }, [props.item]);

  const changePrice = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const price: string = stringTransform(event.target.value.toString());
      if (!floatNumbersValidation(price, 1)) return;
      dealsStore.updateItemDiscountPrice(props.item.id, price);
      // update validation
      if (itemValidation && !itemValidation?.price.state) dealsStore.setValidation();
    },
    [props.item, itemValidation]
  );

  return (
    <li className="deals-item">
      {/* name block */}
      <FakePicker value={getTranslate(props.item.name)} onClick={openItemsModal} className="deals-item__input mr-3" textClassName="family-medium" />
      {/* discounted price */}
      <div className="w-fit-content mr-3">
        <InputAlt
          type="text"
          // space required !!!
          value={props.item.price?.toString() || ' '}
          onInput={changePrice}
          validation={itemValidation ? { ...itemValidation.price, styleType: 'bottom' } : undefined}
          wrapperClassName="deals-item__input"
          className="py-0"
        />
      </div>
      {/* item price */}
      <div className="deals-item__input-price">
        <p className="family-medium color-dark text-size-18">{formatPrice(props.item.product_price || 0)}</p>
      </div>
      {/* delete item button */}
      <div className="d-flex flex-row align-items-center ml-4 mt-2">
        <DeleteRestoreBlock onDelete={handleDelete} iconClassName="color-gray2" />
        <ProductWarning
          type="dealItemsInEditPage"
          comboItem={props.item}
          comboItemOrderTypeWarning={dealsStore.isConflictedItemsOrderType}
          iconSize={21}
          marginLeft={4}
        />
      </div>
    </li>
  );
});

export default DealsItem;
